import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import {toast} from "react-toastify";
import CountUp from "react-countup";
import CardSummary from "../CardSummary";
import Loader from "../../common/Loader";
import {getErrorMessage} from "../../../helpers/cienytech.utils";
import EstadisticasService from "../../../services/estadisticas.service";

const DashboardResumen = () => {
    const [resumen, setResumen] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await EstadisticasService.getDashboardResumen();
                if (cancelled) return;
                setResumen(response.data);
            } catch (error) {
                if (cancelled) return;
                toast.error(getErrorMessage(error));
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    if (isLoading) {
        return <Loader/>;
    }
    
    if (!resumen) {
        return null;
    }

    return (
        <Row>
            <Col md={6} xl={3}>
                <CardSummary
                    title="Presupuestos sin entregar"
                    color="warning"
                    linkText="Ver listado"
                    to="/cienytech/gestion/presupuestos/list"
                >
                    <CountUp end={resumen.presupuestosSinEntregar} duration={2.75} separator="."/>
                </CardSummary>
            </Col>
            <Col md={6} xl={3}>
                <CardSummary
                    title="Albaranes sin confirmar"
                    color="info"
                    linkText="Ver listado"
                    to="/cienytech/gestion/albaranes/list"
                >
                    <CountUp end={resumen.albaranesSinConfirmar} duration={2.75} separator="."/>
                </CardSummary>
            </Col>
            <Col md={6} xl={3}>
                <CardSummary
                    title="Pedidos sin confirmar"
                    color="primary"
                    linkText="Ver listado"
                    to="/cienytech/proveedores/pedidos/list"
                >
                    <CountUp end={resumen.pedidosSinConfirmar} duration={2.75} separator="."/>
                </CardSummary>
            </Col>
            <Col md={6} xl={3}>
                <CardSummary
                    title="Facturas sin firmar"
                    color="success"
                    linkText="Ver listado"
                    to="/cienytech/gestion/facturas/list"
                >
                    <CountUp end={resumen.facturasSinFirmar} duration={2.75} separator="."/>
                </CardSummary>
            </Col>
        </Row>
    );
};

export default DashboardResumen;
